export default {
  migrate() {
    throw new Error('This migration was removed');
  },
};
